module.exports = __webpack_public_path__ + "img/modal-document-confirm.f0b559f2.svg";